import { fetchWithToken } from "../../interceptors/fetchInterceptor";
import {
  API_GET_DATA_AUDIT_ACTIONS_SYSTEM,
  API_USER_HISTORY,
  MAIN_URL,
  PORT_FOR_AUTH,
} from "../../constants/constants";
import { GET_DATA_AUDIT_ACTIONS_SYSTEM, GET_USER_HISTORY } from "../types";

export const getDataAuditActionsSystem = (searchData, page) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL +
        PORT_FOR_AUTH +
        API_GET_DATA_AUDIT_ACTIONS_SYSTEM +
        "page=" +
        page +
        "&size=10",
      {
        method: "POST",
        body: JSON.stringify(searchData),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const responseData = await response.json();

    dispatch({
      type: GET_DATA_AUDIT_ACTIONS_SYSTEM,
      data: responseData,
    });
  };
};

export const getUserHistory = (url, id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_USER_HISTORY + url + id
    );

    const data = await response.json();

    dispatch({
      type: GET_USER_HISTORY,
      data: data,
    });
  };
};
